import { createBrowserRouter, Navigate } from 'react-router';
import { AuthLayout } from '@/layouts/AuthLayout';
import { RootLayout } from '@/layouts/RootLayout';
import { LoginPage } from '@/pages/auth/LoginPage';
import { RegisterPage } from '@/pages/auth/RegisterPage';
import { ForgotPasswordPage } from '@/pages/auth/ForgotPasswordPage';
import { DashboardHomePage } from '@/pages/dashboard/DashboardHomePage';
import { FormsListPage } from '@/pages/forms/FormsListPage';
import { FormCreatePage } from '@/pages/forms/FormCreatePage';
import { FormDetailPage } from '@/pages/forms/FormDetailPage';
import { FormEditPage } from '@/pages/forms/FormEditPage';
import { SubmissionDetailPage } from '@/pages/submissions/SubmissionDetailPage';
import { AnalyticsPage } from '@/pages/analytics/AnalyticsPage';
import { TeamPage } from '@/pages/team/TeamPage';
import { BillingPage } from '@/pages/billing/BillingPage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/dashboard" replace /> },

  // Auth routes (unauthenticated)
  {
    element: <AuthLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/register', element: <RegisterPage /> },
      { path: '/forgot-password', element: <ForgotPasswordPage /> },
    ],
  },

  // Protected routes (authenticated)
  {
    element: <RootLayout />,
    children: [
      { path: '/dashboard', element: <DashboardHomePage /> },
      { path: '/forms', element: <FormsListPage /> },
      { path: '/forms/new', element: <FormCreatePage /> },
      { path: '/forms/:formId', element: <FormDetailPage /> },
      { path: '/forms/:formId/edit', element: <FormEditPage /> },
      { path: '/forms/:formId/submissions/:id', element: <SubmissionDetailPage /> },
      { path: '/analytics', element: <AnalyticsPage /> },
      { path: '/team', element: <TeamPage /> },
      { path: '/billing', element: <BillingPage /> },
      { path: '/settings', element: <SettingsPage /> },
    ],
  },

  { path: '*', element: <NotFoundPage /> },
]);
